import { render, staticRenderFns } from "./ComposeNotification.vue?vue&type=template&id=073caffc&scoped=true"
import script from "./ComposeNotification.vue?vue&type=script&lang=js"
export * from "./ComposeNotification.vue?vue&type=script&lang=js"
import style0 from "./ComposeNotification.vue?vue&type=style&index=0&id=073caffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073caffc",
  null
  
)

export default component.exports